<template>
  <v-tabs v-model="_activeTab">
    <v-tab v-for="tab in tabs" :key="tab">
      {{ tab }}
    </v-tab>
  </v-tabs>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('common', {
      tabs: state => state.toolbarTabs,
      activeTab: state => state.activeTab,
    }),
    _activeTab: {
      get() {
        return this.activeTab
      },
      set(tab) {
        this.$store.commit('common/setActiveTab', tab)
      },
    },
  },
}
</script>
